import React from 'react';

import ExportDataGrid from './ExportDataGrid';

import FormItemUtil from '../utils/FormItemUtil';
import CommandResolver from '../utils/CommandResolver';
import GOTUtil from '../utils/GOTUtil';
import GOT from '../utils/GOT';

import ServiceHelper from '../remote/ServiceHelper';
import Command from '../remote/Command';
import ListDataGrid from './ListDataGrid';
import CommandTask from '../forms/sys/remote/CommandTask';
import Cmd from '../forms/sys/remote/Cmd';

import Fade from'../utils/Fade';
import Warn from '../utils/Warn';
import FormDataSources from '../datasource/FormDataSources';


require('./exportStyle.css');

export default class ExportTable extends React.Component{
	constructor(props, context) {
    	super(props, context);

  		this.state=this.props.htmlarg;
  		this.state.tableColumns=this.setTableColumns(this.state.columns);
  		this.state.saveList=[];
		this.state.title='导出预览';
		this.state.warnTitle = "";		  
  		this.extrals=this.state.extrals;
  		this.all =this.state.columns.slice().concat(this.state.extrals.slice());
  		this.userId = window.parent.window.userInfos.userId;

  		this.state.translateX=0,
  		this.state.translateY=0,
  		this.moving = false;
  		this.lastX = null;
  		this.lastY = null;
  		window.onmouseup = e => this.onMouseUp(e);
  		window.onmousemove = e => this.onMouseMove(e);

		this.state.initExport=this.props.initExport;
  	}
  	
  	componentDidMount=()=>{
  		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"getUserFormExports", 
			"List"
		);
		
		var key=this.state.key;
		command.appendArg(key);
		command.appendArg(this.userId);
		var that=this;
		var _resultHandler = function(data) {that.initSaveList(data);};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg);

		$(this.exportSizeDiv).draggable({
			handle: ".modal-header" // 只能点击头部拖动
		}); //为模态对话框添加拖拽
		let button = $("#gongqi_exportToClipboardModal button")[0];
		if(button && !button.onclick)
		{
			button.onclick = 
				this.onclipboardContentChange.bind(this);
		}
		let close =$("#gongqi_exportToClipboardModal .modal-close")[0];
		if(close && !close.onclick)
		{
			close.onclick = 
				this.onclipboardClose.bind(this);
		}
		if(this.state.initExport){
			this.initOptionsList(this.state.initExport);
		}
	}
	onclipboardClose(exent){
		$("#gongqi_exportToClipboardModal").css("display","none");
	}
	onclipboardContentChange(event)
	{
		var textarea = document.getElementById("exportToClipBoardContent");
		var element = textarea;
		var isReadOnly = element.hasAttribute('readonly');

		if (!isReadOnly) {
			element.setAttribute('readonly', '');
		}
		element.focus();
		element.select();
		element.setSelectionRange(0, element.value.length);

		if (!isReadOnly) {
			element.removeAttribute('readonly');
		}
		let succeeded;
		try {
			succeeded = document.execCommand("copy");
		}
		catch (err) {
			succeeded = false;
		}
		$("#gongqi_exportToClipboardModal").css("display","none");
		if(succeeded == true)
		{
			Fade.show({text:"已复制"});
		}
		else
		{
			Warn.show({text:"复制失败,数据量可能超过系统剪切板设置"});
		}

	}

	
	/** 拖拉 */
	onMouseDown(e) {
	  e.stopPropagation();
	  this.moving = true;
	}

	onMouseUp() {
	  this.moving = false;
	  this.lastX = null;
	  this.lastY = null;
	}

	onMouseMove(e) {
	  this.moving && this.onMove(e);
	}

	onMove(e) {
	//   var height = $("#exportSizeModalContainer").height();
	//   var width = $("#exportSizeModalContainer").width();
	//   console.log(height+","+width);
	//   if (e.clientX < 0) {
	//     return false;
	//   }
	//   if (e.clientY < 0 ) {
	//     return false;
	//   }
	  if (this.lastX && this.lastY) {	
		let dx = e.clientX - this.lastX;
		let dy = e.clientY - this.lastY;
		console.log("dx:"+dx +";dy:"+dy);
	    this.setState({
	      translateX: this.state.translateX + dx,
	      translateY: this.state.translateY + dy
		})
	  }
	  this.lastX = e.clientX;
	  this.lastY = e.clientY;

	  console.log(this.state.translateX,this.state.translateY);
	}
	
  	initSaveList=(data)=>{
  		console.log(data);
  		var result=data.result;
  		var defaultItem;
  		if(result.length>0)
  		{
  			var saveList=[];
  			if(result[0]==null)
  				defaultItem="";
  			else
  				defaultItem=result[0].split(" ")[0];

	  		for(var i=0;i<result.length;i++)
	  		{
	  			var item=result[i];
	  			var itemArr=item.split(" ");
	  			
	  			var list={};
				list['label']=itemArr[1];
				list['fileName']=itemArr[1];
				list['setDefault']=(itemArr[1]==defaultItem)?true:false;
				saveList.push(list);
	  		}

	  		this.setState({saveList:saveList});
  		}
  	}
  	//导出预览保存
  	saveSetting=()=>{
  		$("#exportSaveTable").show();
  	}

  	listToXml=(fileName)=>{
  		var  xmlStr= "<?xml version='1.0' encoding='utf-8'?>";
  		const showTableName=this.state.showTableName;
  		xmlStr+="<nodes showTableName='"+showTableName+"' fileName='"+fileName+"'>";
  		const columns=this.state.columns.slice();
  		for(var i=0;i<columns.length;i++){
  			var column=columns[i];
  			xmlStr+="<node dataField='"+column.dataField+"' fdsfId='"+column.fdsfId+"' fieldType='"+column.fieldType+"' ";
  			xmlStr+="headerText='"+column.headerText+"' isDataMethod='"+column.isDataMethod+"' ";
  			xmlStr+="normalHeaderText='"+column.normalHeaderText+"' ";
  			xmlStr+="selected='"+column.selected+"' ";
  			xmlStr+="formItemId='"+column.formItemId+"' ";
  			xmlStr+="totalHeaderText='"+column.totalHeaderText+"'></node>";
  		}
  		xmlStr+="</nodes>";
  		return xmlStr;
  	}

  	//保存可用列表
  	save=()=>{
  		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"saveUserFormExport", 
			"boolean"
		);
		var key=this.state.key;
		
		command.appendArg(key);
		command.appendArg(this.userId);
		var fileName=$("#exportFileName").val();	
		if(fileName != null && fileName != "")
			command.appendArg(fileName);
		else
			command.appendArg("test");	
		var exportSetting=this.listToXml(fileName);
		var setDefault=$("#exportDefaultBox").prop("checked");
		var saveList=this.state.saveList.slice();
		var fileNameArr=[];
		for(var i=0;i<saveList.length;i++){
			var item=saveList[i];
			fileNameArr.push(item.fileName);
		}
		if($.inArray(fileName,fileNameArr)==-1){
			var list={};
			list['label']=fileName;
			list['fileName']=fileName;
			list['setDefault']=setDefault;
			
			saveList.push(list);
		}
	
		this.setState({saveList:saveList});
		var that=this;
		command.appendArg(exportSetting);
		command.appendArg(setDefault,"boolean");
		var remoteArg = {command:command,resultFunction:function(data) {that.saveSuccess(data,fileName,exportSetting,setDefault,key);},
						 sync:false};
  		ServiceHelper.addTokenWithCommand(remoteArg);
  	}

  	saveSuccess=(data,fileName,exportSetting,setDefault,key)=>{
  		if(data.result){
  			//if(!window.userExportList)window.userExportList = {};

  			if(setDefault){	
				  //window.userExportList[this.key] = exportSetting
				  FormDataSources.setUserDefaultExportList(exportSetting,key);
	  		}else{
				FormDataSources.updateUserDefaultExportListDupName(fileName,key,exportSetting);
	  			/*if(window.userExportList.hasOwnProperty(this.key))
				{
					var defaultSetting = window.userExportList[this.key];
					var doc = (new DOMParser()).parseFromString(defaultSetting,"application/xml");
					var	mainMsg=doc.getElementsByTagName("nodes")[0];
					if(defaultSetting && mainMsg.attributes.fileName.nodeValue==fileName)
					{
						window.userExportList[this.key] = exportSetting;
					}
					
				}*/
	  		}
  		}
  		this.hideExportSaveTable();
  		var options={
  			state:'success'
  		}
  		Fade.show(options);

  	}

  	//加载默认
  	setDefaultData=()=>{
  		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"loadUserDefaultFormExport", 
			"String"
		);
				
		var key=this.state.key;
		
		command.appendArg(key);
		command.appendArg(this.userId);
		var that=this;
		var _resultHandler = function(data){that.setDefaultSuccess(data);};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg);
  	}

  	setDefaultSuccess=(data)=>{
  		var result=data.result;
		var doc = (new DOMParser()).parseFromString(result,"application/xml");
		var	mainMsg=doc.childNodes[0];
		var _showTableName=mainMsg.attributes.showTableName.nodeValue;
		var showTableName=(_showTableName==true||_showTableName=='true')?true:false;
		var fileName=mainMsg.attributes.fileName.nodeValue;
		var columnsMsg=mainMsg.childNodes;
		var dataFieldArr=[];
		var dataFieldNode={};
		for(var i=0;i<columnsMsg.length;i++){
			if(columnsMsg[i].attributes){
				var res = this.state.group.getExportColumnInfo(columnsMsg[i].attributes.fdsfId.nodeValue,columnsMsg[i].attributes.formItemId.nodeValue,columnsMsg[i].attributes.isDataMethod.nodeValue,this.state.group.sources.length>1?true:false);
				// dataFieldArr.push(columnsMsg[i].attributes.dataField.nodeValue);
				if(res){
					dataFieldArr.push(res.oneddatafield);
					dataFieldNode[res.oneddatafield] = columnsMsg[i];
				}else{
					dataFieldArr.push(columnsMsg[i].attributes.dataField.nodeValue);
					dataFieldNode[columnsMsg[i].attributes.dataField.nodeValue] = columnsMsg[i];
				}
			}
			
		}
		var all=this.all;
		var columns=[];
		for(var i=0;i<dataFieldArr.length;i++){
			var columnDataFiled=dataFieldArr[i];
			for(var j=0;j<all.length;j++){
				var item=all[j];
				if(item.dataField==columnDataFiled){
					if(item.totalLabel){
						var column={};
						column['dataField']=item.dataField;
						column['fdsfId']=item.fdsfId;
						column['fieldType']=item.fieldType;
						column['formItemId']=item.formItemId;
						column['isDataMethod']=item.isDataMethod;
						column['normalHeaderText']=item.label;
						column['selected']=item.selected;
						column['totalHeaderText']=item.totalLabel;
						columns.push(column);
					}else{
						item['selected'] = dataFieldNode[columnDataFiled].attributes.selected.nodeValue;
						columns.push(item);
					}
					all.splice($.inArray(item,all),1);
				}
			}
		}

		for(var i=0;i<all.length;i++){
			var item=all[i];
			if(!item.totalLabel){
				var extral={};
				extral['dataField']=item.dataField;
				extral['fdsfId']=item.fdsfId;
				extral['fieldType']=item.fieldType;
				extral['formItemId']=item.formItemId;
				extral['isDataMethod']=item.isDataMethod;
				extral['label']=item.normalHeaderText;
				extral['selected']=item.selected;
				extral['totalLabel']=item.totalHeaderText;
				all.push(extral);
				all.splice($.inArray(item,all),1);
			}
		}
		var title="导出预览"+fileName;
		this.setState({columns:columns,extrals:all,showTableName:showTableName,title:title});
		setTimeout(this.forceUpdate.bind(this),100);
		this.all =this.state.columns.slice().concat(this.state.extrals.slice());
		var options={
  			state:'success'
  		}
  		Fade.show(options);
  	}

	//可用列表
	setOptionsList=()=>{
		var options=[];
		var saveList=this.state.saveList.slice();
		if(saveList.length==0){
			options.push(
					<option key='none'>没有可用列表</option>
				)
		}else{
			for(var i=0;i<saveList.length;i++){
				var list=saveList[i];
				options.push(
					<option value={list.fileName} key={'list'+i}>{list.label}</option>
				)
			}
		}
		return options;
	}

	//选择可用列表
	changeOptionsList=()=>{
		var value=$("#exportLists").val();
		var saveList=this.state.saveList.slice();
		if(value){
			var command = Command.createService( 
				"gongqi.erp.gotmodel.services.UserSettingService", 
				"loadUserFormExport", 
				"String"
			);
					
			var key=this.state.key;
			var that=this;
			
			command.appendArg(key);
			command.appendArg(this.userId);
			command.appendArg(value);		
			var _resultHandler = function(data){that.setOptionSuccess(data)};
			var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
			ServiceHelper.addTokenWithCommand(remoteArg);
		}
		
		
	}
		//手动加载
		initOptionsList=(value)=>{
			var saveList=this.state.saveList.slice();
			if(value){
				var command = Command.createService( 
					"gongqi.erp.gotmodel.services.UserSettingService", 
					"loadUserFormExport", 
					"String"
				);
						
				var key=this.state.key;
				var that=this;
				
				command.appendArg(key);
				command.appendArg(this.userId);
				command.appendArg(value);		
				var _resultHandler = function(data){that.setOptionSuccess(data,value)};
				var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
				ServiceHelper.addTokenWithCommand(remoteArg);
			}
			
			
		}
	
	setOptionSuccess=(data,fileName2 =null)=>{
		var result=data.result;
		var doc = (new DOMParser()).parseFromString(result,"application/xml");
		var	mainMsg=doc.childNodes[0];
		//console.log(mainMsg);
		var _showTableName=mainMsg.attributes.showTableName?mainMsg.attributes.showTableName.nodeValue:false;
		var showTableName=(_showTableName==true||_showTableName=='true')?true:false;
		var fileName=mainMsg.attributes.fileName.nodeValue;
		if(!fileName)fileName=fileName2;
		var columnsMsg=mainMsg.getElementsByTagName("node");
		var columns=[];
		var difference = false;var map = {};
		//console.log(columnsMsg);
		for(var i=0;i<columnsMsg.length;i++){
			
			let _columnItem = columnsMsg[i];

			let fdsfId = _columnItem.attributes.fdsfId.nodeValue;
			let formItemId = _columnItem.attributes.formItemId.nodeValue;
			let isDataMethod = _columnItem.attributes.isDataMethod.nodeValue;
			var _selected=_columnItem.attributes.selected.nodeValue;
			var result = this.state.group.getExportColumnInfo(fdsfId,formItemId,isDataMethod,this.state.group.sources.length>1?true:false);
			if(!result)
			{
				difference = true;
				continue;
			}
			if(result.oneddatafield && map[result.oneddatafield]==true)
			{
			continue;
			}
			map[result.oneddatafield]=true;
			let column = {
							headerText:result.label,normalHeaderText:result.label,dataField:result.oneddatafield,formItemId:formItemId,totalLabel:result.totalLabel,totalHeaderText:result.totalLabel,
							selected:(_selected==true||_selected=='true')?true:false,isDataMethod:isDataMethod,fdsfId:fdsfId
						};
			//if(!_columnItem.attributes.fieldType)alert("保存的设置中没有字段数据类型信息");
			column['fieldType']=_columnItem.attributes.fieldType?_columnItem.attributes.fieldType.nodeValue:result.fieldType;
			columns.push(column);
		}
		var all=this.all;

		for(var i=0;i<columns.length;i++){
			var thisDataField=columns[i].dataField;
			for(var j=0;j<all.length;j++){
				var item=all[j];
				if(item.dataField==thisDataField){
					all.splice($.inArray(item,all),1);
				}
			}
		}
		for(var i=0;i<all.length;i++){
			var item=all[i];
			if(!item.totalLabel){
				var extral={};
				extral['dataField']=item.dataField;
				extral['fdsfId']=item.fdsfId;
				extral['fieldType']=item.fieldType;
				extral['formItemId']=item.formItemId;
				extral['isDataMethod']=item.isDataMethod;
				extral['label']=item.normalHeaderText;
				extral['selected']=item.selected;
				extral['totalLabel']=item.totalHeaderText;
				all.push(extral);
				all.splice($.inArray(item,all),1);
			}
		}
		var title="导出预览  来自设置("+fileName+")";
		var warnTitle = "";
		if(difference == true)
			warnTitle = "由于业务模型更改，您现在看到的设置是拟合后的结果，如有疑问请联系管理员";
		this.setState({columns:columns,extrals:all,showTableName:showTableName,title:title,warnTitle:warnTitle});
		setTimeout(this.forceUpdate.bind(this),100);
		this.all =this.state.columns.slice().concat(this.state.extrals.slice());
		this.hideExportSetTable();
		var options={
  			state:'success'
  		}
		if(fileName2){
			this.state.initExport = undefined;
			return;
		}
  		Fade.show(options);
	}

  	getExportHeadData=()=>{
        var headerInfo = [];
        for(let i = 0;i<this.state.columns.length;i++)
		{
			let col = this.state.columns[i];
			if(col.selected)
			{
				let _headerText = this.state.showTableName?col.totalHeaderText:(col.headerText||col.normalHeaderText);
				let item = {dataField:col.dataField, headerText:_headerText, fieldType:col.fieldType};
				if(col.fieldType == "Decimal")
				{
					if(!col.numOfDecimals)
					{
						for(let key in FormItemUtil.formItemControlsForFor)
	    				{
	      					let fe = FormItemUtil.formItemControlsForFor[key];
	      					if(col.formItemId == fe.xml.id)
	      					{
	      						item.numOfDecimals = fe.getProperty_NumOfDecimals();
	      						break;
	      					}
	      				}	
					}
					else
					{
						item.numOfDecimals = col.numOfDecimals;
					}

					if(typeof(item.numOfDecimals) == "string")
					{
						try
						{
							item.numOfDecimals = parseInt(item.numOfDecimals);
						}
						catch(e)
						{
							item.numOfDecimals = 2;
						}
						
					}
					 
				}
				headerInfo.push(item);
			}
		}
		return headerInfo;
  	}

  	getExportBodyData=(exportHeads)=>{
  		const ac=this.state.ac.slice();
  		var exportBodys=[];
        for(var i=0;i<ac.length;i++){
        	var item=ac[i];
        	var exportBody=[];
        	for(var j =0;j<exportHeads.length;j++){
        		var key=exportHeads[j].dataField;
        		exportBody.push(item[key]);

        	}
        	exportBodys.push(exportBody);
        }
        return exportBodys;
  	}

  	//以Excel导出
  	exportExcel=()=>{

  		var array = this.getExportHeadData();
  		if(!array || array.length == 0)
  		{
  			Fade.show({text:"没有可导出的列"});
  			return;
  		}
  		var label = "";var _group = this.state.group;
		var mainSource = _group.mainSource;	
		var tablePro = GOTUtil.getProperty(mainSource.xml,"Table");
		if(tablePro != null && tablePro.hasOwnProperty("refentityid"))
		{
			var table = GOT.getTable(tablePro.refentityid);
			if(table)
			{
				label = GOTUtil.getPropertyValue(table,"Label");
				if(!label)
				{
					label = mainSource.xml.name;
				}
			}
		}
		
		var command = Command.createService("gongqi.erp.layers.sys.services.ExportService", "exportExcel", "String");
		command.appendArg(label);
		// TODO_YL 数值类型变成String  方便处理
		// for(let ja = 0;ja<array.length;ja++)
		// {
		// 	var fieldd = array[ja];
		// 	if(fieldd.fieldType == "Decimal" || fieldd.fieldType=="Long"){
		// 		fieldd.fieldType ="String";
		// 	}				
		// }

		command.appendArg(array,"List");


		var _exportDataProvider=[];
				
		for(let i = 0;i<this.state.ac.length;i++)
		{
			var item = this.state.ac[i];
			var _exportItem = {};
			for(let j = 0;j<array.length;j++)
			{
				let field = array[j];
				_exportItem[field.dataField] = item[field.dataField]+"";
				if(_exportItem[field.dataField] =='' ||_exportItem[field.dataField] == "undefined" || _exportItem[field.dataField]  ==null ||_exportItem[field.dataField] == "null"){
					if(field.fieldType == "Decimal" || field.fieldType=="Long"){
						_exportItem[field.dataField] = 0;
					}else{
						_exportItem[field.dataField] = "";
					}
				}		
			}
			_exportDataProvider.push(_exportItem);
		}
		command.appendArg(_exportDataProvider,"List");
		//command.appendArg(this.state.ac,"List");
		
		ServiceHelper.addTokenWithCommand({command:command,resultFunction:this.rpc_exportExcelHandler,sync:false});
		return;


  		var options={
  			type:'excel'
  		};
  		var exportHeads=this.getExportHeadData();
       	var exportBodys=this.getExportBodyData(exportHeads);

  		$("#exportDataGrid .react-grid-Grid").tableExport(exportHeads,exportBodys,options);//tbodySelector,theadSelector,type,options
  	}

  	rpc_exportExcelHandler=(data)=>{
  		if(data)
  		{
  			var commandTask = new CommandTask();
	  		commandTask.cmd = Cmd.FileDownload;
	  		commandTask.arg = data.result;
	  		CommandResolver.downLoad(commandTask,window.formModuleInstance);
  		}
  	}

  	//以CSV格式导出
  	exportCSV=()=>{
		let userId = "";
		let _parentWindow = window.parent.window;
		if(_parentWindow)userId = _parentWindow.userInfos.userId;
  		var options={
			  type:'csv',
			  fileName:window.formModuleInstance.formLabel + "_" + new Date().format("yyyyMMddhhmmssS") + "_" + userId
  		};
  		var exportHeads=this.getExportHeadData();
  		if(!exportHeads || exportHeads.length == 0)
  		{
  			Fade.show({text:"没有可导出的列"});
  			return;
  		}
       	var exportBodys=this.getExportBodyData(exportHeads);
  		$("#exportDataGrid .react-grid-Grid").tableExport(exportHeads,exportBodys,options);
  	}

  	//复制到剪贴板
  	exportClipBoard=(e)=>{
  		var exportHeads=this.getExportHeadData();
  		if(!exportHeads || exportHeads.length == 0)
  		{
  			Fade.show({text:"没有可导出的列"});
  			return;
  		}
       	var exportBodys=this.getExportBodyData(exportHeads);
       	var rowCount=exportBodys.length;
       	var data="";
       	var fieldSeparator="\t";
       	var lineSeparator="\n";
       	var fields=[];
       	//循环表头数据
       	for(var i=0;i<exportHeads.length;i++){
       		var filed=exportHeads[i];
       		fields.push(filed.headerText);
       		data += (filed.headerText + fieldSeparator);
       		if(i==exportHeads.length-1){
       			data+=lineSeparator;
       		}
       	}

       	//循环行数据
       	for(var i=0;i<rowCount;i++){
       		var record=exportBodys[i];
       		for(var j=0;j<record.length;j++){
       			var item=record[j];
       			data+=item+fieldSeparator;
       			if(j==record.length-1)
       				data+=lineSeparator;
       		}
       		
		}
		
		var textarea = document.getElementById("exportToClipBoardContent"); //创建input对象  

		textarea.value = data;
		$("#gongqi_exportToClipboardModal p").html("本次共导出"+rowCount+"条数据");
		$("#gongqi_exportToClipboardModal").css("display","flex");
		//return $(textarea).text();
		//$("#gongqi_exportToClipboardModal").css("display","flex");
		//this.clipboardjs.onClick({delegateTarget:textarea});
		//$("#gongqi_exportToClipboardModal #exportToClipBoard").trigger("click");
		
		   
       	/*const copyHandler = (e) => {
		      e.clipboardData.setData('text/plain', data);
		      e.preventDefault();
		};
		document.addEventListener('copy', copyHandler);
		Copy(data);
		document.removeEventListener('copy', copyHandler);
		var options = {
			state: 'success',
			text: '成功复制到剪切板'
		}
		Fade.show(options);*/
	}

  	


  	//导出列checkbox是否选中
  	exportCheckboxState= (ev)=>{
  		var _columns = this.state.columns.slice();
  		for(var i=0;i<_columns.length;i++){
  			if(_columns[i].dataField==ev.target.name){
  				var _selected=($(ev.target).prop("checked")=="true"||$(ev.target).prop("checked")==true)?true:false;
  			  	_columns[i].selected=_selected;
  			}
  		}
  		var tableColumns=this.setTableColumns(_columns);
  		this.setState({columns:_columns,tableColumns:tableColumns});
  		setTimeout(this.forceUpdate.bind(this),100);
  	}

  	//反选控制
  	oppoChoose=(ev)=>{
  		var _columns=this.state.columns.slice();
  		for(var i=0;i<_columns.length;i++){
  			_columns[i].selected=!_columns[i].selected;
  		}
  		var tableColumns=this.setTableColumns(_columns);
  		this.setState({columns:_columns,tableColumns:tableColumns});
  		setTimeout(this.forceUpdate.bind(this),100);
  	}

  	//全选控制
  	allChoose=(ev)=>{
		if(!ev.target)return;
		let _selected = ev.target.checked; 
  		var _columns=this.state.columns.slice();
  		for(var i=0;i<_columns.length;i++){
  			_columns[i].selected=_selected;
  		}
  		var tableColumns=this.setTableColumns(_columns);
  		this.setState({columns:_columns,tableColumns:tableColumns});
  		setTimeout(this.forceUpdate.bind(this),100);
  	}

  	//多表关联是否显示表名
  	changeTableNameState=(ev)=>{
  		var _showTable=($(ev.target).prop("checked")==true||$(ev.target).prop("checked")=="true")?true:false;

  		this.setState({showTableName:_showTable});
  		setTimeout(this.forceUpdate.bind(this),100);
  	}

  	allowDrop = (ev) => {
		ev.preventDefault();
	}

	  drag = (ev) =>
	  {
		/*var btn=document.createElement("BUTTON");
		var t=document.createTextNode("CLICKxxx");
		btn.appendChild(t);*/
		let helper = $("#exportDragHelper");
		helper.empty();
		let parent = $(ev.target).parent();
		let uiSelected = parent.find(">div.ui-selected");
		helper.append(uiSelected.clone());
		let ids = [];
		uiSelected.each(function(index,item){

			ids.push(this.id);

		});
		ev.dataTransfer.setData("Text",ids);
		//let cloned1 = $("#EquipCodePointTable\\.codePointld").clone();
		//let cloned2 = $("#EquipCodePointTable\\.codePointName").clone();
		//let div = $("<div style='display:flex;flex-direction:column'></div>").append(cloned1).append(cloned2);
		ev.dataTransfer.setDragImage(helper[0],0,0);
	}

	drop =(ev) =>{
		ev.preventDefault();
		var data=ev.dataTransfer.getData("Text");
		if(!data)return;
		var datas = data.split(",");
		var _columns = this.state.columns.slice();
		var _extrals = this.state.extrals.slice();
		if(ev.target.id=='chooseableColumns'){
		
			for(var i=_columns.length-1;i>=0;i--){
				var column=_columns[i];
				if(datas.indexOf(column.dataField) != -1){
				//if(column.dataField==data){
					var extral={};
					extral['dataField']=column.dataField;
					extral['fdsfId']=column.fdsfId;
					extral['fieldType']=column.fieldType;
					extral['formItemId']=column.formItemId;
					extral['isDataMethod']=column.isDataMethod;
					extral['label']=column.normalHeaderText;
					extral['selected']=column.selected;
					extral['totalLabel']=column.totalHeaderText;
					if(column.numOfDecimals)
						extral['numOfDecimals'] = column.numOfDecimals;
					_extrals.push(extral);
					_columns.splice($.inArray(column,_columns),1);
				}

			}
		}else if(ev.target.parentNode.id=='chooseableColumns'){
			var thisIndex;
			//先找到拖拽代理放置的那个节点的索引
			for(var i=0;i<_extrals.length;i++){
				var extrals=_extrals[i];
				if(extrals.dataField==ev.target.id){
					thisIndex=$.inArray(extrals,_extrals);
				}
			}
			var j=0;
			for(var i=_columns.length-1;i>0;i--)
			{
				var column=_columns[i];
				//if(column.dataField==data)
				if(datas.indexOf(column.dataField) != -1)
				{
					var extral={};
					extral['dataField']=column.dataField;
					extral['fdsfId']=column.fdsfId;
					extral['fieldType']=column.fieldType;
					extral['formItemId']=column.formItemId;
					extral['isDataMethod']=column.isDataMethod;
					extral['label']=column.normalHeaderText;
					extral['selected']=column.selected;
					extral['totalLabel']=column.totalHeaderText;
					if(column.numOfDecimals)
						extral['numOfDecimals'] = column.numOfDecimals;
					_extrals.splice(thisIndex,0,extral);
					_columns.splice($.inArray(column,_columns),1);
				}
				else
				{
					j++
				}
			}
			if(j==_columns.length){
				for(var i=_extrals.length-1;i>=0;i--){
					var extral=_extrals[i];
					if(datas.indexOf(extral.dataField)!=-1){
					//if(extral.dataField==data){
						_extrals.splice($.inArray(extral,_extrals),1);
						_extrals.splice(thisIndex,0,extral);
					}
				}
			}
		}else if(ev.target.id=="exportColumns"){
			for(var i=_extrals.length-1;i>=0;i--){
				var extral=_extrals[i];
				if(datas.indexOf(extral.dataField) != -1){
				//if(extral.dataField==data){
					var column={};
					column['dataField']=extral.dataField;
					column['fdsfId']=extral.fdsfId;
					column['fieldType']=extral.fieldType;
					column['formItemId']=extral.formItemId;
					column['isDataMethod']=extral.isDataMethod;
					column['headerText'] = column['normalHeaderText']=extral.label;
					column['selected']=extral.selected;
					column['totalHeaderText']=extral.totalLabel;
					if(extral.numOfDecimals)
						column['numOfDecimals'] = extral.numOfDecimals;
					_columns.push(column);
					_extrals.splice($.inArray(extral,_extrals),1);
				}
			}
		}else if(ev.target.parentNode.id=='exportColumns'){
			var thisIndex;
			for(var i=0;i<_columns.length;i++){
				var column=_columns[i];
				if(column.dataField==ev.target.id){
					thisIndex=$.inArray(column,_columns);
				}
			}
			var j=0;thisIndex--;if(!thisIndex||thisIndex<0)thisIndex=0;
			for(var i=_extrals.length-1;i>=0;i--){
				var extral=_extrals[i];
				//if(extral.dataField==data){
				if(datas.indexOf(extral.dataField) != -1){
					var column={};
					column['dataField']=extral.dataField;
					column['fdsfId']=extral.fdsfId;
					column['fieldType']=extral.fieldType;
					column['formItemId']=extral.formItemId;
					column['isDataMethod']=extral.isDataMethod;
					column['normalHeaderText']=extral.label;
					column['selected']=extral.selected;
					column['totalHeaderText']=extral.totalLabel;
					if(extral.numOfDecimals)
						column['numOfDecimals'] = extral.numOfDecimals;
					_columns.splice(thisIndex,0,column);
					thisIndex++;
					_extrals.splice($.inArray(extral,_extrals),1);
				}else{
					j++;
				}
			}
			if(j==_extrals.length){
				var nextIndex;
				for(var i=_columns.length-1;i>=0;i--){
					var column=_columns[i];
					//if(column.dataField==data){
					if(datas.indexOf(column.dataField) != -1){
						_columns.splice($.inArray(column,_columns),1);
						_columns.splice(thisIndex,0,column);
					}
				}
			}
		}
	 	var tableColumns=this.setTableColumns(_columns);
	    this.setState({columns:_columns,extrals:_extrals,tableColumns:tableColumns});   
		setTimeout(this.forceUpdate.bind(this),100);
		$("#exportDragHelper").empty();
		$(this.chooseableColumnsNode).find(">div.ui-selected").removeClass("ui-selected");
		$(this.exportColumnsContentNode).find(">div.ui-selected").removeClass("ui-selected");
	}

	onDragEnterHandler = (ev) =>
	{
		$(ev.target).addClass("ui-selected");
	}

	onDragLeaveHandler = (ev) =>
	{
		$(ev.target).removeClass("ui-selected");
	}
	
	setTableColumns=(_columns)=>{
		var tableColumns=[];
		var dataFieldArr=[];
	    for(var i=0;i<_columns.length;i++){

	      	
	      	//判断重复dataField
	      	if(dataFieldArr.indexOf(_columns[i].dataField)==-1){
	      		var column={};
		      	column['key']=_columns[i].dataField;
		      		dataFieldArr.push(_columns[i].dataField);
		      	if(this.state.showTableName){
		      		column['name']=_columns[i].totalHeaderText;
		      	}else{
		      		column['name']=_columns[i].normalHeaderText;
		      	}
		      	column['width']=120;
		      	column['resizable']='true';
		      	column['sortable']='true';
		      	if(_columns[i].selected)
		     		tableColumns.push(column);
	      	}
	      		
	      	
	      	
	    }
	    return tableColumns;
	}

	//设置导出列
	setExportColumns =() =>{
		var list=[];
		var exportColumns = this.state.columns.slice();
		for(var i=0;i<exportColumns.length;i++){
			let _selected = exportColumns[i].selected;
			
			if(this.state.showTableName){
				list.push(
					<div onDragEnter={this.onDragEnterHandler} onDragLeave={this.onDragLeaveHandler} onMouseDown={this.exportColumnMouseDown} onMouseUp={this.exportolumnMouseUp} draggable='true' onDragStart={this.drag} id={exportColumns[i].dataField} key={'drop'+i} style={{position:'relative',paddingLeft:'5px'}}>
						<input type='checkbox' checked={_selected} onClick={this.exportCheckboxState} id={"export_input_"+exportColumns[i].dataField} name={exportColumns[i].dataField}/>
						<label htmlFor={"export_input_"+exportColumns[i].dataField}></label>{exportColumns[i].totalHeaderText}				
					</div>
				)
			}else{
				list.push(
					<div onDragEnter={this.onDragEnterHandler} onDragLeave={this.onDragLeaveHandler} onMouseDown={this.exportColumnMouseDown} onMouseUp={this.exportolumnMouseUp} draggable='true' onDragStart={this.drag} id={exportColumns[i].dataField} key={'drop'+i} style={{position:'relative',paddingLeft:'5px'}}>
						<input type='checkbox' checked={_selected} onClick={this.exportCheckboxState} id={"export_input_"+exportColumns[i].dataField} name={exportColumns[i].dataField}/>
						<label htmlFor={"export_input_"+exportColumns[i].dataField}></label>{exportColumns[i].normalHeaderText}				
					</div>
				)
			}
		}
		return list;
	}

	chooseableColumnMouseDown = (e) =>
	{
		var _selectable= $(this.chooseableColumnsNode);
        if(!e.ctrlKey && !e.shiftKey){ //没有按下Ctrl或Shift键
          if(!$(e.target).hasClass("ui-selected")){
            _selectable.find(">div").removeClass("ui-selected");
          }
          $(e.target).addClass("ui-selected");
          this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);

		}
		else if(e.ctrlKey && !e.shiftKey)
		{ //只按下Ctrl键
          $(e.target).addClass("ui-selected");
          this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);
		}
		else if((!e.ctrlKey && e.shiftKey) || (e.ctrlKey && e.shiftKey))
		{ //只按下Shift键或Ctrl和Shift键都按下
          _selectable.find(">div").removeClass("ui-selected");
          $(e.target).addClass("ui-selected");

		  if(this.chooseable_selected_begin_index!=undefined)
		  {
            this.chooseable_selected_end_index=_selectable.find(">div").index(e.target);
		  }
		  else
		  {
            this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);
          }

		  if(this.chooseable_selected_end_index>=this.chooseable_selected_begin_index)
		  {
			for(var i=this.chooseable_selected_begin_index;i<=this.chooseable_selected_end_index;i++)
			{
              _selectable.find(">div").eq(i).addClass("ui-selected");
            }
		  }
		  else
		  {
			for(var i=this.chooseable_selected_end_index;i<=this.chooseable_selected_begin_index;i++)
			{
              _selectable.find(">li").eq(i).addClass("ui-selected");
            }
          }

        }
	}

	exportColumnMouseDown = (e) =>
	{
		var _selectable= $(this.exportColumnsContentNode);
        if(!e.ctrlKey && !e.shiftKey){ //没有按下Ctrl或Shift键
          if(!$(e.target).hasClass("ui-selected")){
            _selectable.find(">div").removeClass("ui-selected");
          }
          $(e.target).addClass("ui-selected");
          this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);

		}
		else if(e.ctrlKey && !e.shiftKey)
		{ //只按下Ctrl键
          $(e.target).addClass("ui-selected");
          this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);
		}
		else if((!e.ctrlKey && e.shiftKey) || (e.ctrlKey && e.shiftKey))
		{ //只按下Shift键或Ctrl和Shift键都按下
          _selectable.find(">div").removeClass("ui-selected");
          $(e.target).addClass("ui-selected");

		  if(this.chooseable_selected_begin_index!=undefined)
		  {
            this.chooseable_selected_end_index=_selectable.find(">div").index(e.target);
		  }
		  else
		  {
            this.chooseable_selected_begin_index=_selectable.find(">div").index(e.target);
          }

		  if(this.chooseable_selected_end_index>=this.chooseable_selected_begin_index)
		  {
			for(var i=this.chooseable_selected_begin_index;i<=this.chooseable_selected_end_index;i++)
			{
              _selectable.find(">div").eq(i).addClass("ui-selected");
            }
		  }
		  else
		  {
			for(var i=this.chooseable_selected_end_index;i<=this.chooseable_selected_begin_index;i++)
			{
              _selectable.find(">li").eq(i).addClass("ui-selected");
            }
          }

        }
	}

	chooseableColumnMouseUp = (e) =>
	{
		var _selectable= $(this.chooseableColumnsNode);
        if(!e.ctrlKey && !e.shiftKey){ //没有按下Ctrl或Shift键
          _selectable.find(">div").removeClass("ui-selected");
          $(e.target).addClass("ui-selected");

        }
	}

	exportColumnMouseUp = (e) =>
	{
		var _selectable= $(this.exportColumnsContentNode);
        if(!e.ctrlKey && !e.shiftKey){ //没有按下Ctrl或Shift键
          _selectable.find(">div").removeClass("ui-selected");
          $(e.target).addClass("ui-selected");

        }
	}

	//设置可选列
	setChooseableColumns = () =>{
		var list=[];
		var chooseableColumns=this.state.extrals.slice();
		for(var i=0;i<chooseableColumns.length;i++)
		{
			let label;
			if(this.state.showTableName)
			{
				label = chooseableColumns[i].totalLabel;
			}
			else
			{
				label = chooseableColumns[i].label;
			}

			list.push(
				<div onDragEnter={this.onDragEnterHandler} onDragLeave={this.onDragLeaveHandler} onMouseUp={this.chooseableColumnMouseUp} onMouseDown={this.chooseableColumnMouseDown} draggable='true' onDragStart={this.drag} id={chooseableColumns[i].dataField} key={'drag'+i}>
					{label}
				</div>
			);
		}
		return list;
	}

	hideExportTable=()=>{
		$("#exportModal").empty();

	}

	hideExportSaveTable=()=>{
		$("#exportSaveTable").hide();
	}

	showExportSetTable=()=>{
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"getUserFormExportsWithDefault", 
			"List"
		);
		var key=this.state.key;
		
		command.appendArg(key);
		command.appendArg(this.userId);
		var that=this;		
		var remoteArg = {command:command,resultFunction:function(data){that.getListDataGridRows(data)},sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg)
		
	}

	getListDataGridRows=(data)=>{
		var result=data.result;
		var listRows=[];

		for(var i=1;i<result.length;i++){
			var listRow={};
			var item=result[i];
			var itemArr=item.split(" ");
			listRow['userName']=itemArr[0];
			listRow['fileName']=itemArr[1];
			listRows.push(listRow);
		}
		window.ListDataGrid.setState({rows:listRows});
		var defaultItem;
		if(result[0]){
			defaultItem=result[0].split(" ")[1];
		}
		
		this.exportSetTableTitle(defaultItem);
		$("#exportSetTable").show();
		
	}

	setTableSelectedFileName=()=>{
		let selectedIndex=window.ListDataGrid.state.selectedIndexes[0];
		var rows=window.ListDataGrid.state.rows.slice();
		if(!rows||rows.length==0)
			return
		if(selectedIndex>=rows.length||selectedIndex<0)
			return
		var fileName=rows[selectedIndex].fileName;

		return fileName;
	}

	setTableSelectedUserName=()=>{
		let selectedIndex=window.ListDataGrid.state.selectedIndexes[0];
		var rows=window.ListDataGrid.state.rows.slice();
		var userName=rows[selectedIndex].userName;
		return userName;
	}

	resetExportTable=()=>{
		var fileName=this.setTableSelectedFileName();
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"loadUserFormExport", 
			"String"
		);
					
		var key=this.state.key;
		var that=this;
		let selectedIndex=window.ListDataGrid.state.selectedIndexes[0];
		var rows=window.ListDataGrid.state.rows.slice();
		var userName=rows[selectedIndex].userName;
		command.appendArg(key);
		command.appendArg(userName);
		command.appendArg(fileName);
		var remoteArg = {command:command,resultFunction:function(data){that.setOptionSuccess(data)},sync:false};		
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	//删除
	deleteExportList=()=>{
		var fileName=this.setTableSelectedFileName();
		var delDefault;
		var saveList=this.state.saveList.slice();
		for(var i=0;i<saveList.length;i++){
			if(saveList[i].setDefault){
				delDefault=true;
			}
		}
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"deleteUserFormExport", 
			"void"
		);
					
		var key=this.state.key;
		var that=this;
		
		command.appendArg(key);
		command.appendArg(this.userId);
		command.appendArg(fileName);	
		var _resultHandler = function(data)
		{
			if(delDefault)
			{
				FormDataSources.setUserDefaultExportList(null,that.key);
				//window.userExportList[that.key] = null;
				//delete window.userExportList[that.key];
			}
			var saveList=that.state.saveList.slice();
			for(var i=0;i<saveList.length;i++){
				if(saveList[i].fileName==fileName){
					saveList.splice(saveList[1],1);
				}
			}
			that.setState({saveList:saveList})
			window.ListDataGrid.deleteRow();
			var options={
	  			state:'success'
	  		}
	  		Fade.show(options);
		};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	//设为默认
	setDefaultList=()=>{
		var fileName=this.setTableSelectedFileName();
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"setUserDefaultFormExport", 
			"String"
		);
					
		var key=this.state.key;
		
		command.appendArg(key);
		command.appendArg(this.userId);
		var userId=this.setTableSelectedUserName();
		command.appendArg(userId);
		command.appendArg(fileName);		
		var that=this;
		var _resultHandler = function(data){that.setDefaultListSuccess(data,fileName);};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg);
	}

	setDefaultListSuccess=(data,fileName)=>{
		//if(!window.userExportList)window.userExportList={};
		if(data.result)
				//window.userExportList[this.key] = data.result;
				FormDataSources.setUserDefaultExportList(data.result,this.state.key);

		this.exportSetTableTitle(fileName);
		var options={
	  		state:'success'
	  	}
	  	Fade.show(options);

	}
	exportSetTableTitle=(defaultItem)=>{
	
		if(defaultItem){
			$("#exportListDefaultItem").text("当前默认值"+defaultItem).attr("name",defaultItem);
			$("#cancelExportListDefaultItem").show();
		}else{
			$("#exportListDefaultItem").text("当前默认值 没有默认值");
			$("#cancelExportListDefaultItem").hide();
		}
		

	}

	//取消默认
	deleteDefaultFileName=()=>{
		var title=$("#exportListDefaultItem").attr("name");
		var command = Command.createService( 
			"gongqi.erp.gotmodel.services.UserSettingService", 
			"unsetUserDefaultFormExport", 
			"void"
		);
					
		var key=this.state.key;
		
		command.appendArg(key);
		command.appendArg(this.userId);		
		var that=this;
		var _resultHandler = function(data){

			/*if(window.userExportList&&window.userExportList[that.key]){
				window.userExportList[that.key] = null;
				delete window.userExportList[that.key];	
			}*/
			FormDataSources.setUserDefaultExportList(null,that.key);
			
			$("#exportListDefaultItem").text("当前默认值 没有默认值");
			var options={
	  			state:'success'
	  		}
	  		Fade.show(options);
			$("#cancelExportListDefaultItem").hide();
		};
		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
		ServiceHelper.addTokenWithCommand(remoteArg)
		
		//title 文件名
	}


	//筛选当前用户
	selectDefaultUser=()=>{
		var defaultUser=this.userId;
		var rowsList=window.ListDataGrid.state.rows.slice();
		this.rowsListBak=rowsList.slice();
		console.log(this.rowsListBak);
		for(var i=0;i<rowsList.length;i++){
			if(rowsList[i].userName!=defaultUser){
				rowsList.splice($.inArray(rowsList[i],rowsList),1);
			}
		}
		window.ListDataGrid.setState({rows:rowsList});
		$("#selectUser").hide();
		$("#cancelSelect").show();
	}

	//取消筛选
	cancelSelectDefaultUser=()=>{
		console.log(this.rowsListBak);
		window.ListDataGrid.setState({rows:this.rowsListBak});
		$("#selectUser").show();
		$("#cancelSelect").hide();
	}

	hideExportSetTable=()=>{
		$("#exportSetTable").hide();
	}
		//选择可用列表
	// initDefExport=(value)=>{
	// 	if(value){
	// 		var command = Command.createService( 
	// 			"gongqi.erp.gotmodel.services.UserSettingService", 
	// 			"loadUserFormExport", 
	// 			"String"
	// 		);
	// 		var key=this.state.key;
	// 		var that=this;
	// 		command.appendArg(key);
	// 		command.appendArg(this.userId);
	// 		command.appendArg(value);		
	// 		var _resultHandler = function(data){that.setOptionSuccess(data)};
	// 		var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
	// 		ServiceHelper.addTokenWithCommand(remoteArg);
	// 	}
	// }
	

  	render(){
  		var _rows=this.state.ac.slice();
  		const chooseableColumnsContent=this.setChooseableColumns();
  		const exportColumnsContent=this.setExportColumns();
  		const optionsList=this.setOptionsList();
  		var _columns = this.setTableColumns(this.state.columns.slice());
  		var showTableName=this.state.showTableName;
  		const title=this.state.title;
  		var exportSetTableTitle=this.exportSetTableTitle();
      let modalCloseStyle = {}
      let outerStyle = {height:'415px'}
	  let modalBodyStyle = {padding:'0px 15px',display:'flex',flexDirection:'row',alignItems:'stretch'}
	  let modalHeaderStyle = {};
      if(window.didomain || window.parent.window.didomain){
        if($(document.body).width() <900 || $(document.body).height() <500){
          modalCloseStyle.top = '8px';modalHeaderStyle.paddingTop = '4px';modalHeaderStyle.paddingBottom = '4px';
          outerStyle.height = '256px';
          modalBodyStyle.maxHeight = '280px'
        }
      }
  		return(
	  		<div>
	  			<div className='modal' id="exportSizeModalContainer" style={{display:'flex',flexDirection:'column',justifyContent:'center',alignItems:'center'}} key="mainModal">
		      		<div ref={node=>this.exportSizeDiv = node} className='modal-content' style={{display:'flex',flexDirection:'column',alignItems:'stretch',justifyContent:'center',overflow:'auto',background:'#FFFFFF',border:'1px solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
		        		<div className='modal-header' style={modalHeaderStyle}>
		          			<div className="modal-close"  style={modalCloseStyle} onClick={this.hideExportTable}></div>
		          			<h5 className='modal-title'>{title}</h5>
		        		</div>
						   <div className='modal-body' style={modalBodyStyle}>
		       				<div style={{marginBottom:'0',WebkitTouchCallout:'none',WebkitUserSelect:'none',MozUserSelect:'none',msUserSelect:'none',user
					:'none'}}>
								<div className='box-header with-border'>
			              			<div style={{fontFamily:'STSongti-SC-Regular',fontSize:'14px',color:'#000000',fontWeight:'normal',marginTop:'2px',marginBottom:'5px'}}>可选列</div>
			            		</div>
			            		<div className='box-body' style={{height:'93%',marginTop:'5px',padding:'0',marginRight:'14px'}}>
									<div ref={node=>this.chooseableColumnsNode=node} id='chooseableColumns' style={outerStyle} onDrop={this.drop} onDragOver={this.allowDrop}>
										{chooseableColumnsContent}
									</div> 
								</div>
							</div>
							<div style={{marginBottom:'0',WebkitTouchCallout:'none',WebkitUserSelect:'none',MozUserSelect:'none',msUserSelect:'none',user
					:'none'}}>
								<div className='box-header with-border'>
									<div style={{fontFamily:'STSongti-SC-Regular',fontSize:'14px',color:'#000000',fontWeight:'normal',marginTop:'2px',marginBottom:'5px'}}>导出列</div>
								</div>
								<div className='box-body'  style={{height:'93%',marginTop:'5px',padding:'0',marginRight:'11px'}}>
									<div ref={node=>this.exportColumnsContentNode=node} id='exportColumns' style={outerStyle} onDrop={this.drop} onDragOver={this.allowDrop}>
										{exportColumnsContent}
									</div>
								</div>
							</div>
							<div style={{flexGrow:100,display:'flex',flexDirection:'column',marginTop:this.state.warnTitle?'4px':'27px',marginBottom:'1px',marginLeft:'2px'}}>
								<div style={{color:'orangered'}}>{this.state.warnTitle}</div>
								<ExportDataGrid columns={_columns} rows={_rows}/>
							</div>
		       			</div>
		        		<div className='modal-footer' style={{padding:'10px 15px 8px',borderTopColor:'rgba(0,0,0,0.10)',marginTop:'10px',borderTop:'1px solid rgba(0,0,0,0.10)'}}>
		        		
		            		<div>
			            		<div style={{display: 'inline-block',marginRight:'47px',position:'relative'}}>
									<input id="export_column_allChoose" type='checkbox' onClick={this.allChoose} style={{marginRight:'11px'}}/><label htmlFor="export_column_allChoose" style={{marginRight:'10px',marginRight:'10px',padding:'0px',width:'18px',height:'18px',marginBottom:'0px',top:'1px',left:'0px'}}></label>全选控制
		                 			<input id="export_column_oppoChoose" type='checkbox' onClick={this.oppoChoose} style={{marginLeft:'15px'}}/><label htmlFor="export_column_oppoChoose" style={{marginRight:'10px',marginRight:'10px',padding:'0px',width:'18px',height:'18px',marginBottom:'0px',top:'1px',left:'76px'}}></label>反选控制
			                 		<input id="export_column_mutiTableShowName" type='checkbox' checked={showTableName} onClick={this.changeTableNameState} style={{marginRight:'15px'}}/>多表关联时显示表名<label htmlFor="export_column_mutiTableShowName" style={{top:'1px',left:'151px'}}></label>
			            		</div>
			        			<button type='button' className='btn btn-info' onClick={this.saveSetting} style={{height:'28px',width:'88px'}}><i style={{marginRight:'3px'}} className="fa fa-download" aria-hidden="true"></i>保存</button>
			          			<button type='button' className='btn btn-info' onClick={this.setDefaultData} style={{height:'28px',width:'118px'}}><i style={{marginRight:'3px'}} className="fa fa-spinner" aria-hidden="true"></i>加载默认</button>
					          	<button type='button' className='btn btn-info' onClick={this.showExportSetTable} style={{height:'28px',width:'88px'}}><i style={{marginRight:'3px'}} className="fa fa-cog" aria-hidden="true"></i>设置</button>
					          	<select className='btn btn-info' style={{padding:'4.2px 12px !important',width:'100px',height:'28px'}} onChange={this.changeOptionsList} id="exportLists">
					            	<option style={{display: 'none'}} key='title'>可用列表</option>
					            	{optionsList}
					          	</select>
					          	<button type='button' className='btn btn-info' onClick={this.exportExcel} style={{height:'28px',width:'110px'}}>导出到Excel</button>
					          	<button type='button' className='btn btn-info' onClick={this.exportCSV} style={{height:'28px',width:'110px'}}>导出到CSV</button>
					          	<button onClick={this.exportClipBoard} ref={node=>this.exportToClipBoard = node} type='button' className='btn btn-info' style={{height:'28px',width:'110px'}}>导出到剪贴板</button>
		        			</div>
		        		</div>
		      		</div>
			   	</div>

					<div className="modal" id="exportSaveTable" key="saveModal" style={{zIndex: '2000'}}>
				    <div className="modal-dialog" style={{marginTop:'100px',width:'640px'}}>
			            <div className="modal-content" style={{
							    background:'#FFFFFF',
								border: '1px solid #9B9B9B',
								boxShadow: '0 0 41px 5px rgba(0,0,0,0.25)',
								borderRadius: '2px'
						}}>
			              <div className="modal-header">
			               
							<div className="modal-close" onClick={this.hideExportSaveTable}></div>
			                <h4 className="modal-title" style={{marginTop:'0',marginBottom:'0'}}>保存</h4>
			              </div>
			              <div className="modal-body" style={{display:'flex',flexDirection:'column',padding:'40px 10px'}} >
								<div style={{flexGrow:0,textAlign:'center'}} >
							  		<div style={{display:'flex',flexDirection:'row',paddingLeft:'35px'}}>
									  <div style={{textAlign:'right'}} >
										<label style={{paddingTop:'8px',fontFamily:'STSongti-SC-Regular',fontSize:'12px',color:'#000000',fontWeight:'normal'}} >文件名：</label> 
							  		  </div>
							  		  <div style={{textAlign:'left',flexGrow:1,marginRight:'10px'}}>
										<input type="text" spellcheck="false" className="form-control" id="exportFileName"/>
									  </div>
									</div>
								</div>
								<div style={{flexGrow:1,textAlign:'center',paddingLeft:'83px'}} >
									<div style={{display:'flex',flexDirection:'row'}} >
										<div style={{display:'flex',alignItems:'center',textAlign:'left',position:'relative'}} >
											<input type="checkbox" id="exportDefaultBox" style={{width:'16px',height:'16px'}}/>
											<label htmlFor="exportDefaultBox" style={{top:'7px',marginLeft:'2px'}}></label>
										</div>
										<div style={{textAlign:'right',paddingLeft:'3px'}}>
											<label style={{paddingTop:'6px',fontSize:'14px',fontFamily:'STSongti-SC-Regular',color:'#4A90E2'}} >设为默认</label>
										</div>
										
									</div>
								</div>
			              </div>
			              <div className="modal-footer" style={{padding:'10px 15px'}}>
			                <button type="button" className="btn" style={{height:'28px',marginRight:'5px',width:'80px',background:'#FFFFFF',border:'1px solid #D1D1D1',borderRadius:'2px',paddingTop:'3px'}} id="userFormSetSaveModal_BtnCancel" data-dismiss="modal" onClick={this.hideExportSaveTable}>取消</button>
			                <button type="button" className="btn" style={{height:'28px',marginRight:'0px',width:'80px',fontFamily:'STSongti-SC-Regular',fontSize:'14px',border:'solid 1px #f5a623',letterSpacing:0,textAlign:'center',backgroundColor:'#f5a623',paddingTop:'3px',color:'#fff'}}  onClick={this.save}>保存</button>
			              </div>
			            </div>
			        </div>
			  	</div>

			   	<div className="modal" id="exportSetTable" style={{zIndex: '2000',display: 'none'}}>
			    	<div className="modal-dialog" style={{width: '600px',backgroundColor: '#fff'}}>
				      	<div className="modal-content" style={{marginTop:'100px',background:'#FFFFFF',border:'0 solid #9B9B9B',boxShadow:'0 0 41px 5px rgba(0,0,0,0.25)',borderRadius:'2px'}}>
				        	<div className="modal-header">
								<div className="modal-close" onClick={this.hideExportSetTable}></div>
					          	<h5 className="modal-title" style={{fontWeight:'bolder'}}>已保存列表</h5>
				          	</div>
				          	<div className="modal-content">
					          	<div className="box" style={{borderTop: '1px solid #d2d6de',textAlign:'center'}}>
					            	<div className="box-header with-border" style={{textAlign:'left',background:'#FAFAFA',marginLeft:'10px',marginRight:'10px',height:'40px',borderLeft:'solid 3px #0178D4',paddingTop:'10px',display:'flex',alignItems:'center',borderBottom:'none'}}>
					            		<span className="box-title" id="exportListDefaultItem" style={{marginLeft:'10px',fontSize:'14px',fontWeight:'inherit'}}></span>
										<button type="button" id="cancelExportListDefaultItem" className="btn btn-info" data-dismiss="modal" onClick={this.deleteDefaultFileName}>取消</button>
					              		
					            	</div>
					            	<div className="box-body" style={{height: '290px'}}>
								 		<div style={{width:'100%',height:'100%'}}>
										 	<ListDataGrid/>
										</div>
					            	</div>

					            	<div className="box-footer" id="userSetTable-footer" style={{marginTop:'5px',textAlign:'right',borderTop:'1px solid rgba(0,0,0,0.10)'}}>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.resetExportTable} style={{marginLeft:'5px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-spinner"></i>加载</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.deleteExportList} style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-trash-o" aria-hidden="true"></i>删除</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.selectDefaultUser} id="selectUser" style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-filter" aria-hidden="true"></i>筛选当前用户</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" style={{display: 'none',marginLeft:'8px',marginRight:'0'}} onClick={this.cancelSelectDefaultUser} id="cancelSelect"><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-filter" aria-hidden="true"></i>取消筛选</button>
					              		<button type="button" className="btn btn-info" data-dismiss="modal" onClick={this.setDefaultList} style={{marginLeft:'8px',marginRight:'0'}}><i style={{marginTop:'1px',marginRight:'2px',float:'left'}} className="fa fa-cog" aria-hidden="true"></i>设为默认</button>
					            	</div>
					         	</div>
					        </div>
				        </div>
				  	</div>
				</div>

			  	
			</div>


			  	
  		)
  	}
}


// WEBPACK FOOTER //
// ./src/export/ExportTable.js